import { Actions, ButtonLink, IconRenderer } from 'braid-design-system';

import file from './DeveloperDashboardGuide.pdf';
import { FilePdfIcon } from '@phosphor-icons/react';

export const DeveloperDashboardGuide = () => (
  <Actions>
    <ButtonLink
      href={file}
      icon={
        <IconRenderer>
          {({ className }) => <FilePdfIcon className={className} />}
        </IconRenderer>
      }
      rel="noreferrer"
      target="_blank"
      variant="soft"
    >
      Developer Dashboard Guide
    </ButtonLink>
  </Actions>
);
